export type ClientDevice = 'IOS' | 'Android'
export type ClientOs = ClientDevice

declare global {
  interface Window {
    __DEVICE__?: ClientDevice
    __OS__?: ClientDevice
  }
}

/**
 * 注入到 <head> 中的微型同步内联脚本。
 * 作用：在浏览器解析 <body> 之前，立刻识别客户端设备并在 <html> 上标记 class (IOS / Android)，
 * 同时写入 window.__DEVICE__ 和 window.__OS__，从根源上杜绝内容闪烁（Zero-FOUC），并保证 SSR / CDN 缓存和 SEO 完全一致。
 */
export const CLIENT_OS_INLINE_SCRIPT = `
(() => {
  try {
    var p = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';
    var ua = navigator.userAgent || '';
    var isIos = /mac/i.test(p) || /macintosh|mac os x|iphone|ipad|ipod/i.test(ua);
    var device = isIos ? 'IOS' : 'Android';
    var doc = document.documentElement;
    if (doc && doc.classList) {
      if (typeof doc.classList.remove === 'function') {
        doc.classList.remove('IOS', 'Android', 'os-mac', 'os-windows');
      }
      doc.classList.add(device);
    }
    window.__DEVICE__ = device;
    window.__OS__ = device;
  } catch (e) {}
})();
`.trim()

export const useClientOs = () => {
  // 服务端默认使用 Android，客户端水合时同步为真实客户端设备
  const clientDevice = useState<ClientDevice>('client-device-type', () => 'Android')

  if (import.meta.client && (window.__DEVICE__ || window.__OS__)) {
    clientDevice.value = (window.__DEVICE__ || window.__OS__) as ClientDevice
  }

  useHead(() => ({
    htmlAttrs: {
      class: clientDevice.value === 'IOS' ? 'IOS' : 'Android',
    },
    script: [
      {
        key: 'detect-client-os',
        tagPosition: 'head',
        innerHTML: CLIENT_OS_INLINE_SCRIPT,
      },
    ],
  }))

  return {
    clientDevice,
    clientOs: clientDevice,
  }
}

export const useClientDevice = useClientOs
